import type { ITableSpecificSettings } from "../types";

interface IProps {
  isMobile: boolean;
  hasEditorData: boolean;
  tableMobileLayout: ITableSpecificSettings["tableMobileLayout"];
}

export const shouldRenderMobileCards = ({
  isMobile,
  hasEditorData,
  tableMobileLayout,
}: IProps): boolean =>
  isMobile && !hasEditorData && tableMobileLayout === "card";
